import { learningApi } from '../../../services/api'

/**
 * Planning API
 *
 * IMPORTANTE: Não usa localStorage.getItem('token') diretamente.
 * O token é gerenciado automaticamente pelos interceptores do axios
 * configurados em src/services/api.ts, garantindo que sempre use
 * o token do usuário corrente da sessão Redux.
 */
export const planningApi = {
  /**
   * Get available contests for study schedule
   */
  getContests: async (page = 1, limit = 50, search?: string) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    })

    if (search && search.trim()) {
      params.append('search', search.trim())
    }

    const response = await learningApi.get(`/study-plan/public-tenders?${params.toString()}`)
    return response.data
  },

  /**
   * Get disciplines for a specific contest/course
   */
  getDisciplines: async (courseId: string) => {
    const response = await learningApi.get(`/study-plan/disciplines?course=${courseId}`)
    return response.data
  },

  /**
   * Generate study schedule based on user parameters
   */
  generateSchedule: async (data: any) => {
    const response = await learningApi.put('/study-plan', data)
    return response.data
  },

  /**
   * Save user's study schedule
   */
  saveSchedule: async (scheduleData: any) => {
    const response = await learningApi.post(`/study-plan/${scheduleData.planId}`, scheduleData)
    return response.data
  },

  /**
   * Get user's saved schedules
   */
  getSavedSchedules: async () => {
    const response = await learningApi.get('/study-plan')
    return response.data
  },

  /**
   * Get a saved schedule by ID
   */
  getScheduleById: async (scheduleId: string) => {
    const response = await learningApi.get(`/study-plan/${scheduleId}`)
    return response.data
  },

  /**
   * Delete a saved schedule
   */
  deleteSchedule: async (scheduleId: string) => {
    const response = await learningApi.delete(`/study-plan/${scheduleId}`)
    return response.data
  },

  /**
   * Get sessions by plan ID
   */
  getSessionsByPlanId: async (scheduleId: string) => {
    const endpoint = `/study-plan/${scheduleId}/sessions`
    const response = await learningApi.get(endpoint)
    return response.data
  },

  /**
   * Get progress info by module ID
   */
  getProgressInfoByModuleId: async (courseId: string, moduleId: string) => {
    const endpoint = `/course/${courseId}/modules/${moduleId}/progress-info`
    const response = await learningApi.get(endpoint)
    return response.data
  },

  /**
   * Patch cycle session status
   */
  patchCycleSession: async (scheduleId: string, sessionId: string, status: string) => {
    const endpoint = `/study-plan/${scheduleId}/sessions/${sessionId}`
    const response = await learningApi.patch(endpoint, { status })
    return response.data
  },

  /**
   * Restart cycle
   */
  restartCycle: async (scheduleId: string) => {
    const endpoint = `/study-plan/${scheduleId}/restart`
    const response = await learningApi.post(endpoint, {})
    return response.data
  },
}
